var _rect, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 0,
    width: 40,
    height: 100,
    fill: "gray"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    stroke: "white",
    strokeWidth: 5,
    strokeDasharray: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighway);
export default __webpack_public_path__ + "static/media/highway.42e24b46d829f51a9c178e9ff8d0842d.svg";
export { ForwardRef as ReactComponent };